import { type PropsWithChildren, type ReactNode } from 'react'
import { OverlayTrigger, Tooltip, type OverlayTriggerProps } from 'react-bootstrap'
import { useInteractiveOverlay } from '../../common/useInteractiveOverlay'

interface InteractiveTooltipProps {
  content: ReactNode
  placement?: OverlayTriggerProps['placement']
  offset?: OverlayTriggerProps['offset']
}

/**
 * A tooltip wrapper that remains visible while the user hovers over its content,
 * enabling interaction with links or buttons inside the overlay.
 */
export const InteractiveTooltip: React.FC<PropsWithChildren<InteractiveTooltipProps>> = ({ content, placement = 'top', offset, children }) => {
  const { overlayTriggerProps, hoverHandlers } = useInteractiveOverlay()

  return (
    <OverlayTrigger {...overlayTriggerProps} placement={placement} offset={offset} overlay={<Tooltip {...hoverHandlers}>{content}</Tooltip>}>
      <span {...hoverHandlers}>{children}</span>
    </OverlayTrigger>
  )
}
